"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscribeEvent = void 0;
const abstract_event_1 = require("../abstract.event");
class SubscribeEvent extends abstract_event_1.AbstractEvent {
    constructor(config) {
        super(config);
        this.config = config;
        this.name = 'subscribe';
    }
    getData() {
        return {
            email: this.config.email,
            list: this.config.list,
            allow_marketing: this.config.allow_marketing,
            allow_sms_marketing: this.config.allow_sms_marketing,
            allow_policy: this.config.allow_policy,
            language: this.config.language,
            source: this.config.source
        };
    }
}
exports.SubscribeEvent = SubscribeEvent;
//# sourceMappingURL=subscribe.event.js.map